import { render } from "./RatioContent.vue?vue&type=template&id=6c296b5e"
import script from "./RatioContent.vue?vue&type=script&lang=js"
export * from "./RatioContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__